export default __webpack_public_path__ + "static/1.1-Text-Images-DONT-9743e6eb8e02ee3d99521bb870d90968.png";